import { cardPreviewContext } from '@context/card-preview-context';
import { useCardAttribute } from '@hooks/use-card-attributes';
import { useContext } from 'react';

import { SingleInputCardProperty } from '../SingleInputCardProperty';
import styles from './Headline.module.scss';
import type { CardProperty } from '.cache/__types__';

type HeadlineProps = {
  property?: CardProperty;
  // In future, cardId could come from the cardFieldEditContext (or similar context), that way we can tell if there is no
  // cardId, that we need to create a new card before adding the property.
  cardId: string;
};

export const Headline: React.FC<HeadlineProps> = ({ property, cardId }) => {
  const { hideEmptyAttributes } = useContext(cardPreviewContext);

  const cardAttributeType = useCardAttribute('headline');
  if (!cardAttributeType) {
    return null;
  }

  // if hideEmptyAttributes specified as true and property value empty, then headline shouldn't be shown on the card at all
  if (hideEmptyAttributes && !property?.value) {
    return <></>;
  }

  return (
    <div className={styles['user-headline-container']}>
      <SingleInputCardProperty
        attribute={cardAttributeType}
        cardId={cardId}
        className={styles['user-headline']}
        inputLabel="Headline"
        property={property}
        defaultTemplateValueProvider={'member'}
      />
    </div>
  );
};
